import * as O from 'fp-ts/Option';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/lib/function';
import { useMatchStatsQuery } from '../../../generated/graphql';
import { isAssistEvent, isCardEvent, isScorerEvent } from './utils';

type Options = Omit<
  NonNullable<Parameters<typeof useMatchStatsQuery>[0]>,
  'variables'
>;

export const useMatchStats = (matchId: string, options: Options = {}) => {
  const [matchStatsResponse] = useMatchStatsQuery({
    variables: { id: matchId },
    requestPolicy: 'cache-and-network',
    ...options,
  });

  const events = O.fromNullable(matchStatsResponse.data?.match?.events);

  const scorers = pipe(
    events,
    O.map(A.filter(isScorerEvent)),
    O.filter(A.isNonEmpty),
    O.toNullable,
  );

  const assists = pipe(
    events,
    O.map(A.filter(isAssistEvent)),
    O.filter(A.isNonEmpty),
    O.toNullable,
  );

  const cards = pipe(
    events,
    O.map(A.filter(isCardEvent)),
    O.filter(A.isNonEmpty),
    O.toNullable,
  );

  return {
    fetching: matchStatsResponse.fetching,
    stats: { scorers, assists, cards },
    error: matchStatsResponse.error,
  };
};
